import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOffAltOutlinedIcon from "@mui/icons-material/ThumbDownOffAltOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import Comments from "../components/Comments";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  dislike,
  fetchVideoError,
  fetchVideoStart,
  fetchVideoSuccess,
  like,
} from "../redux/videoSlice";
import { formatDistanceToNow } from "date-fns";
import { library, subscription } from "../redux/userSlice";
import Recommendations from "../components/Recommendations";
import { axiosInstance } from "../utils/axiosConfig";
import Swal from "sweetalert2";
import Loader from "../components/Loader";

const Container = styled.div`
  display: flex;
  gap: 1rem;
`;

const Content = styled.div`
  flex: 7;
`;

const VideoWrapper = styled.div``;

const Title = styled.h1`
  font-size: 18px;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.text};
`;

const Details = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Info = styled.span`
  color: ${({ theme }) => theme.textSoft};
`;

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  color: ${({ theme }) => theme.text};
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;

const Hr = styled.hr`
  margin: 15px 0px;
  border: 0.5px solid ${({ theme }) => theme.softHr};
`;

const Channel = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ChannelInfo = styled.div`
  display: flex;
  gap: 20px;
`;

const ChannelImg = styled.img`
  flex: 1;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #999;
`;

const ChannelDetail = styled.div`
  flex: 11;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.text};
`;

const ChannelName = styled.span`
  font-weight: 500;
`;

const ChannelCounter = styled.span`
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.textSoft};
`;

const VideoDescription = styled.p`
  font-size: 14px;
`;

const SubsribeButton = styled.button`
  background-color: ${(props) =>
    props.isSub ? "rgba(255, 255, 255, 0.1)" : "#cc1a00"};
  font-weight: 500;
  color:  ${({ theme }) => theme.text};
  height: max-content;
  border: none;
  border-radius: 3px;
  padding: 10px 20px;
  cursor: pointer;
`;

const Video = () => {
  const dispatch = useDispatch();
  const videoId = useLocation().pathname.split("/")[2];
  const { currentVideo, loading } = useSelector((state) => state.video);
  const { loggedInUser } = useSelector((state) => state.user);
  const [channel, setChannel] = useState({});
  const { videos } = useSelector((state) => state.videos);
  // console.log("user",loggedInUser);
  useEffect(() => {
    const addView = async () => {
      try {
        await axiosInstance.put(`/videos/view/${videoId}`);
      } catch (error) {
        console.log(error);
      }
    };

    const fetchVideo = async () => {
      dispatch(fetchVideoStart());
      try {
        let videoIndex = videos.findIndex((video) => video._id === videoId);
        if (videoIndex !== -1) {
          let video = videos[videoIndex];
          dispatch(fetchVideoSuccess(video));
          addView();
        } else {
          dispatch(fetchVideoSuccess(null));
        }
      } catch (error) {
        dispatch(fetchVideoError());
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error.response.data.error || "Error occured while fetching video",
        });
      }
    };

    fetchVideo();
  }, [dispatch, videoId, videos]);

  useEffect(() => {
    const fetchChannel = async () => {
      try {
        const res = await axiosInstance.get(`/users/${currentVideo?.userId}`);
        // setChannel((prev) => res.data.user);
        setChannel(res.data.user);
        // console.log(res.data)
      } catch (error) {
        console.log(error);
      }
    };

    if (currentVideo?._id===videoId) {
      fetchChannel();
    }
  }, [currentVideo]);
  
  // add to history
  useEffect(() => {
      const addHistory=async()=>{
          if (!loggedInUser) {
            return;
        }
        try {
         await axiosInstance.put(`/users/history/${currentVideo?._id}`,{
              headers: {
              Authorization: `${loggedInUser.token}`
            }
          }) 
        } catch (error) {
          console.log(error);
        }
      }
       if (currentVideo?._id===videoId) {
          addHistory();
       }
  }, [currentVideo])
  

  const handleLike = async () => {
    if (!loggedInUser) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Sign In required!",
      });
      return;
    }
    try {
      await axiosInstance.put(`/users/like/${currentVideo?._id}`,{
          headers: {
          Authorization: `${loggedInUser.token}`
        }
      });
      dispatch(like(loggedInUser.user?._id));
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response.data.error ||
          "Error occured while handling likes of the video",
      });
    }
  };

  const handleDislike = async () => {
    if (!loggedInUser) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Sign In required!",
      });
      return;
    }
    try {
      await axiosInstance.put(`/users/dislike/${currentVideo?._id}`,{
          headers: {
          Authorization: `${loggedInUser.token}`
        }
      });
      dispatch(dislike(loggedInUser.user?._id));
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response.data.error ||
          "Error occured while handling dislikes of the video",
      });
    }
  };

  const handleSubscription = async () => {
    if (!loggedInUser) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Sign In required!",
      });
      return;
    }
    try {
      loggedInUser.user.subscribedUsers.includes(channel?._id)
        ? await axiosInstance.put(`/users/unsub/${channel?._id}`,{
          headers: {
          Authorization: `${loggedInUser.token}`
        }
      })
        : await axiosInstance.put(`/users/sub/${channel?._id}`,{
          headers: {
          Authorization: `${loggedInUser.token}`
        }
      });
      dispatch(subscription(channel?._id));
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response.data.error ||
          "Error occured while handling subscriptions of the user",
      });
    }
  };

  // for library ======>

   const handleSaved = async () => {
    if (!loggedInUser) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Sign In required!",
      });
      return;
    }
    try {
      loggedInUser.user.saved?.includes(currentVideo?._id) ? 
      await axiosInstance.put(`/users/unsaved/${currentVideo?._id}`,{
          headers: {
          Authorization: `${loggedInUser.token}`
        }
      }) :await axiosInstance.put(`/users/saved/${currentVideo?._id}`,{
          headers: {
          Authorization: `${loggedInUser.token}`
        }
      }) ;
      dispatch(library(currentVideo?._id));
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response.data.error ||
          "Error occured while handling save the video",
      });
    }
  };
  const handleCopyURL = async () => {
    try {
      const text = window.location.href;
      await navigator.clipboard.writeText(text);
      
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }

  if (loading || !currentVideo) {
    return <Loader />;
  }

  return (
    <Container>
      <Content>
        <VideoWrapper>
          <iframe
            width="600"
            height="315"
            src={currentVideo?.videoUrl}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </VideoWrapper>
        <Title>{currentVideo && currentVideo.title}</Title>
        <Details>
          <Info>
            {currentVideo && currentVideo.views + 1} views •{" "}
            {currentVideo &&
              formatDistanceToNow(new Date(currentVideo.createdAt), {
                addSuffix: true,
              })}
          </Info>
          <Buttons>
            <Button onClick={handleLike}>
              {currentVideo &&
              currentVideo.likes?.includes(loggedInUser.user?._id) ? (
                <ThumbUpIcon />
              ) : (
                <ThumbUpOutlinedIcon />
              )}{" "}
              {currentVideo && currentVideo.likes?.length}
            </Button>
            <Button onClick={handleDislike}>
              {currentVideo &&
              currentVideo.dislikes?.includes(loggedInUser.user?._id) ? (
                <ThumbDownIcon />
              ) : (
                <ThumbDownOffAltOutlinedIcon />
              )}
              Dislike
            </Button>
            <Button onClick={handleCopyURL}>
              <ShareOutlinedIcon /> 
            </Button>
            <Button onClick={handleSaved} >
              <AddTaskOutlinedIcon /> 
               {loggedInUser &&
            loggedInUser.user.saved?.includes(currentVideo?._id)
              ? "remove"
              : "save"}
            </Button>
          </Buttons>
        </Details>
        <Hr />
        <Channel>
          <ChannelInfo>
            <ChannelImg src={channel?.img} />
            <ChannelDetail>
              <ChannelName>{channel?.name}</ChannelName>
              <ChannelCounter>
                {channel?.subscribers?.length} Subscribers
              </ChannelCounter>
              <VideoDescription>
                {currentVideo && currentVideo.description}
              </VideoDescription>
            </ChannelDetail>
          </ChannelInfo>
          <SubsribeButton
            onClick={handleSubscription}
            isSub={
              loggedInUser &&
              loggedInUser.user.subscribedUsers?.includes(channel?._id)
                ? true
                : false
            }
          >
            {loggedInUser &&
            loggedInUser.user.subscribedUsers?.includes(channel?._id)
              ? "SUBSCRIBED"
              : "SUBSCRIBE"}
          </SubsribeButton>
        </Channel>
        <Hr />
        {currentVideo && (
          <Comments videoId={currentVideo._id} loggedInUser={loggedInUser} />
        )}
      </Content>
      {currentVideo && <Recommendations tags={currentVideo.tags} />}
    </Container>
  );
};

export default Video;